/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntraSecurityGroupResponse
 */
export interface EntraSecurityGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof EntraSecurityGroupResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntraSecurityGroupResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the EntraSecurityGroupResponse interface.
 */
export function instanceOfEntraSecurityGroupResponse(value: object): value is EntraSecurityGroupResponse {
    return true;
}

export function EntraSecurityGroupResponseFromJSON(json: any): EntraSecurityGroupResponse {
    return EntraSecurityGroupResponseFromJSONTyped(json, false);
}

export function EntraSecurityGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntraSecurityGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
    };
}

export function EntraSecurityGroupResponseToJSON(json: any): EntraSecurityGroupResponse {
    return EntraSecurityGroupResponseToJSONTyped(json, false);
}

export function EntraSecurityGroupResponseToJSONTyped(value?: EntraSecurityGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
    };
}

